var _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5537 10.4324C20.108 5.26388 10.7733 -1.97211 0.999979 10.4324C4.28906 15.601 15.0961 22.1792 23.5537 10.4324Z",
    stroke: "#2E7161"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.16856,
    cy: 5.16856,
    r: 4.66856,
    transform: "matrix(-1 0 0 1 17.4551 5.26392)",
    stroke: "#2E7161"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.82955,
    cy: 1.82955,
    r: 1.82955,
    transform: "matrix(-1 0 0 1 14.3384 8.46216)",
    fill: "#2E7161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7076 3.29219C20.8684 3.06767 21.1807 3.01598 21.4052 3.17674C21.6297 3.3375 21.6814 3.64983 21.5207 3.87436L20.7076 3.29219ZM19.1198 5.5097L20.7076 3.29219L21.5207 3.87436L19.9329 6.09186L19.1198 5.5097Z",
    fill: "#2E7161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0762 0.999969C12.0762 0.723826 12.3 0.499969 12.5762 0.499969C12.8523 0.499969 13.0762 0.723826 13.0762 0.999969L12.0762 0.999969ZM12.0762 3.72729L12.0762 0.999969L13.0762 0.999969L13.0762 3.72729L12.0762 3.72729Z",
    fill: "#2E7161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76638 4.24612C2.5852 4.03772 2.60727 3.72191 2.81567 3.54073C3.02407 3.35955 3.33988 3.38162 3.52106 3.59002L2.76638 4.24612ZM4.55577 6.30437L2.76638 4.24612L3.52106 3.59002L5.31044 5.64827L4.55577 6.30437Z",
    fill: "#2E7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSee);
export default __webpack_public_path__ + "static/media/see.cd55f0111b20aa169682183eb551ff09.svg";
export { ForwardRef as ReactComponent };